import L from 'leaflet';
import iconLocation from '../../img/icon.svg'
import useSettingsApi from "../../hooks/useSettingsApi";

//import markers icon css
import './MarkersIcon.css'

//re-import leaflet icon
import icon from 'leaflet/dist/images/marker-icon.png';
import iconRetina from 'leaflet/dist/images/marker-icon-2x.png';
import iconShadow from 'leaflet/dist/images/marker-shadow.png';

//Custom icon for the location marker
const LocationMarkerIcon = new L.Icon({
    iconUrl: iconLocation,
    iconRetinaUrl: iconLocation,
    iconSize: [24,24],
    className: 'leaflet-div-icon location-icon'
});

//Custom basic icon the stores markers
const BaseMarkerIcon = (settings) => {

    const iconMarker = settings ? settings['iconMarker'] ? settings['iconMarker']['thumbnail'] : false : false

    return new L.Icon({
        iconUrl: iconMarker ? iconMarker[0] : icon,
        iconRetinaUrl: iconMarker ? iconMarker[0] : iconRetina,
        iconSize: [iconMarker ? iconMarker[1] : 25, iconMarker ? iconMarker[2] : 41],
        iconAnchor: [iconMarker ? iconMarker[1]/2 : 12.5,iconMarker ? iconMarker[2] : 41],
        popupAnchor: [0,iconMarker ? -iconMarker[2] : -41],
    });
}

export { LocationMarkerIcon, BaseMarkerIcon };